<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title" v-if="userInfo.userType != 3">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算周期：
          <span class="num">{{ settlementDate }}</span>
        </div>

        <div class="item settlement-status">
          发布状态：
          <div v-if="detailData.releaseStatus == 0" class="tag-settled">未发布</div>
          <div v-else class="tag-be">已发布</div>
        </div>
      </div>
    </div>

    <div class="statistics-container">
      <p>合计</p>
      <div class="statistics-item">
        <div class="item">
          机构数：
          <span class="num">{{ statisticsObj.orgNum || 0 }}</span>
        </div>
        <div class="item">
          总人数：
          <span class="num">{{ statisticsObj.userNum || 0 }}</span>
        </div>
        <div class="item">
          总单量：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
        </div>
        <div class="item">
          总保费：
          <span class="num">{{ statisticsObj.fee || 0 }}</span>
        </div>
        <div class="item">
          基本法收益：
          <span class="num">{{ statisticsObj.methodIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          基本法外基础费用
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 355px">
              <span>活动费用、后置费用等</span>
              <!-- <span>含个险首期续期基础费用、团财基础费用（含批单）、后置费用</span> -->
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.baseIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          无门槛限时加费：
          <span class="num">{{ statisticsObj.platformActivityIncome || 0 }}</span
          >元
        </div>
        <div class="item" v-if="!($units.isOkBao() || $units.isOkTX())">
          团队长管理费：
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 380px">
              <span>个险首期续期基础费用、后置费用、团财（含批单）的团队长管理费</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.baseLeaderIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          其他活动收益：
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 235px">
              <span>除无门槛限时加费的其他活动收益的总和</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.activityIncome || 0 }}</span
          >元
        </div>
        
        <div class="item" v-if="$units.isOkBao() || $units.isOkTX()">
          基本法扣款
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 320px">
              <span>因保单退保，出单时产生的已结算基本法利益需全额退回。</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.methodDeductIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          加扣款：
          <span class="num">{{ statisticsObj.deduction || 0 }}</span
          >元
        </div>
        <div class="item">
          税前合计：
          <span class="num">{{ statisticsObj.totalIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          个税：
          <span class="num">{{ statisticsObj.tax || 0 }}</span
          >元
        </div>
        <div class="item" v-if="$units.isOkBao() || $units.isOkTX()">
          增值税：
          <span class="num">{{ statisticsObj.valueAddTax || 0 }}</span
          >元
        </div>
        <div class="item" v-if="$units.isOkBao() || $units.isOkTX()">
          附加税：
          <span class="num">{{ statisticsObj.additionalTax || 0 }}</span
          >元
        </div>
        <div class="item">
          税后合计：
          <span class="num">{{ statisticsObj.totalIncomeSubTax || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <Tabs v-model="tabVal" @on-click="clickTabs" class="tab">
      <TabPane label="业务员明细" name="1"></TabPane>
      <TabPane label="按机构汇总" name="2"></TabPane>
    </Tabs>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <div class="search-tools" v-if="tabVal == 1">
        <div class="search-box btn3">
          <div class="input-item">
            <span class="label">业务员</span>
            <lzSelect v-model="search.userId" placeholder="请输入姓名或工号搜索" :remote-method="getUserList">
              <template slot-scope="{ list }">
                <Option v-for="(item, i) in list" :key="i" :value="item.id">
                  <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                  {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
                </Option>
              </template>
            </lzSelect>
          </div>
          <Button type="primary" @click="searchAjax()">搜索</Button>
        </div>
      </div>
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>

        <div slot-scope="{ row }" slot="platformActivity">
          <Poptip placement="bottom" width="400">
            <span style="cursor: pointer" class="table-btn">{{ row.platformActivityIncome }}</span>
            <div class="api" slot="content">
              <Table
                :columns="[
                  { title: '活动名称', key: 'activityName', align: 'center' },
                  { title: '活动收益', key: 'income', align: 'center' }
                ]"
                :data="row.platformActivityVolist"
              ></Table>
            </div>
          </Poptip>
        </div>

        <div slot-scope="{ row }" slot="activity">
          <Poptip placement="bottom" width="400">
            <span style="cursor: pointer" class="table-btn">{{ row.activityIncome }}</span>
            <div class="api" slot="content">
              <Table
                :columns="[
                  { title: '活动名称', key: 'activityName', align: 'center' },
                  { title: '活动收益', key: 'income', align: 'center' }
                ]"
                :data="row.activityVolist"
              ></Table>
            </div>
          </Poptip>
        </div>

        <template slot-scope="{ row }" slot="deductionAction">
          <span class="table-btn" @click="openDeduction(row)">{{ row.deduction }}</span>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">明细</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back('/financialManage/salesmanPaySettlement')" v-if="step == 2">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.releaseStatus == 0 && userInfo.userType != 3">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.releaseStatus == 1 && userInfo.userType != 3">上一步</Button>
      <Tooltip
        content="可手动导入其他收入项或扣款项，每次重新导入后覆盖原数据"
        placement="top"
        style="margin: 0 10px"
        max-width="250"
        v-if="userInfo.userType != 3"
      >
        <Button class="btn" @click="importPlusDeduction" :disabled="detailData.releaseStatus == 1 ? true : false">导入加扣款</Button>
      </Tooltip>
      <Button class="btn" @click="countTax" :disabled="detailData.releaseStatus == 1 ? true : false" v-if="userInfo.userType != 3">计算个税</Button>
      <Button class="btn" @click="importDataTax" :disabled="detailData.releaseStatus == 1 ? true : false" v-if="userInfo.userType != 3">导入扣税</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>

      <Tooltip content="发布后业务员可以在前端看到全部收益项并提现" :disabled="$units.isOkBao()" placement="top" style="margin: 0 10px" max-width="320" v-if="userInfo.userType != 3">
        <Button type="primary" class="btn" @click="toReleaseStatus">{{ detailData.releaseStatus == 1 ? '撤销发布' : '发布' }}</Button>
      </Tooltip>
    </div>

    <!-- 导入 -->
    <import-modal ref="importModal" @success="clickTabs(tabVal)"></import-modal>

    <!-- 业务员加扣款 -->
    <salesman-deduction ref="salesmanDeduction" :reportId="reportId" @success="clickTabs(1)"></salesman-deduction>

    <!-- 机构加扣款 -->
    <org-deduction ref="orgDeduction" :reportId="reportId" @success="clickTabs(2)"></org-deduction>
  </div>
</template>

<script>
import importModal from '../components/importModal';
import salesmanDeduction from '../components/salesmanDeduction';
import orgDeduction from '../components/orgDeduction';
import lzSelect from '@/components/commons/lzSelect';
import { common, pageTool } from '@/api/mixins';
import { config } from './step2.config.js';
import { mapState } from 'vuex';
import filter from '@/api/filter';

export default {
  mixins: [common, pageTool, config],
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  components: {
    importModal,
    lzSelect,
    salesmanDeduction,
    orgDeduction
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      reportId: null,
      reportName: '',
      settlementDate: '',
      statisticsObj: {},
      step: null,
      columns: [],
      search: {},
      columns1: [],
      columns2: [],
      tabVal: '1',
      tableData: [],
      total: 0,
      detailData: {}
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
    if (reportId) {
      this.clickTabs(this.tabVal);
    }
  },
  methods: {
    setData() {
      const { reportId, settlementDate, reportName } = this.backData;
      this.reportId = reportId;
      this.settlementDate = settlementDate;
      this.reportName = reportName;
      this.clickTabs(this.tabVal);
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword || keyword.includes('-')) {
        return;
      }
      const params = {
        orgaList: [],
        userName: keyword
      };
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/userSalaryReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/userSalaryDetails/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    clickTabs(value) {
      if (value == 1) {
        this.getColumns1();
      } else {
        this.getColumns2();
      }
      this.pageNum = 1;
      this.getList();
      this.getDetailData();
      this.getStatisticsData();
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSalaryDetails/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          groupType: this.tabVal,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.search
        }
      })
        .then(res => {
          res.data.map(item => {
            item.settlementDate = this.settlementDate;
            if(this.$units.isOkBao() || this.$units.isOkTX()) {
              item.costAmount = (Number(item.totalIncome) - Number(item.tax) - Number(item.valueAddTax) - Number(item.additionalTax)).toFixed(2);
            }else{
              item.costAmount = (Number(item.totalIncome) - Number(item.tax)).toFixed(2);
            }
          });
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 上一步
    backOperate() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/userSalaryDetails/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0 });
      });
    },

    // 已发布上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 计算个税
    countTax() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('您确定要计算个税吗，计算后将覆盖当前个税数据?').then(() => {
        this.$http({
          url: '/buz/userSalaryDetails/buildTax',
          type: 'POST',
          data: {
            reportId: this.reportId
          }
        }).then(res => {
          this.$notice.success('计算成功');
          this.clickTabs(this.tabVal);
        });
      });
    },

    // 导入加扣款
    importPlusDeduction() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.importModal.open({
        dicKey: 'DEDUCTION_IMPORT', //下载模板字典
        uploadUrl: '/buz/userSalaryDeduction/upload', //上传接口
        reportId: this.reportId,
        name: '导入加扣款'
      });
    },

    // 导入扣税
    importDataTax() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.importModal.open({
        uploadUrl: '/buz/userSalaryDetails/uploadTax', //上传接口
        reportId: this.reportId,
        downloadFun: () => {
          this.$http({
            url: '/buz/userSalaryDetails/getImportTaxUrl',
            type: 'GET',
            data: {}
          }).then(res => {
            this.$units.downloadFile(res.data, {}, 'GET', '个税导入模板.xls');
          });
        },
        name: '导入个税'
      });
    },

    // 发布
    toReleaseStatus() {
      if (!this.$units.pointAction('offline_81_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`您确定要${this.detailData.releaseStatus == 1 ? '撤销发布' : '发布'}吗?`).then(() => {
        this.$http({
          url: this.detailData.releaseStatus == 1 ? '/buz/userSalaryReport/revoke' : '/buz/userSalaryReport/release',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.$notice.success(`${this.detailData.releaseStatus == 1 ? '撤销' : '发布'}成功`);
          this.getDetailData();
        });
      });
    },

    // 加扣款
    openDeduction(row) {
      if (this.tabVal == 1) {
        this.$refs.salesmanDeduction.open(row.userId, this.detailData.releaseStatus);
      } else {
        this.$refs.orgDeduction.open(row.orgId, this.detailData.releaseStatus);
      }
    },

    // 导出
    exportReport() {
      if (!this.$units.pointAction('offline_81_2_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/userSalaryDetails/export', { reportId: this.reportId }, 'POST');
    },

    // 保单明细
    detailsPage(row) {
      this.openPageTabTags('/financialManage/salesmanPaySettlement/detail', {
        reportId: this.reportId,
        tabVal: this.tabVal,
        orgId: row.orgId,
        userId: row.userId,
        title: `${row.staffNo}/${row.userName}${filter.filterTime(row.settlementDate, 'YYYY-MM-DD')}综合薪酬明细`,
        pageType: 'pay'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  display: flex;
  font-size: 15px;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.dian {
  display: inline-block;
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;
      width: 300px;
      .num {
        color: #ff7134;
      }

      .label {
        position: relative;

        .tip-icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #9c9c9c;
          color: #a8a6a6;
          display: inline-block;
          text-align: center;
          line-height: 14px;
          font-size: 14px;
          cursor: pointer;
          top: 50%;
        }

        .tip-icon:hover + .pop-tip {
          opacity: 0.9;
          z-index: 9999;
          display: block;
        }

        .pop-tip {
          position: absolute;
          width: 250px;
          top: -42px;
          display: flex;
          align-items: center;
          text-align: left;
          left: 50%;
          margin-left: -90px;
          padding: 6px 10px;
          display: flex;
          flex-direction: column;
          background-color: #444444;
          display: none;
          border-radius: 4px;

          span {
            font-size: 12px;
            font-weight: 500;
            color: #fff;
          }

          .arrow {
            position: absolute;
            width: 12px;
            height: 12px;
            background-color: #444444;
            opacity: 0.9;
            bottom: -4px;
            left: 74px;
            transform: rotateZ(135deg);
          }
        }
      }
    }
  }
}
.tab {
  margin-top: 10px;
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
